module.exports = __webpack_public_path__ + "img/img12.93123d90.svg";